import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";

const TomorrowBarchart = ({ chartdata, displaychart }) => {
  const [chartOptions, setChartOptions] = useState({});
  const [chartSeries, setChartSeries] = useState([]);
  const { value } = displaychart || {};
  const genderValue = value === "0" ? "both" : Number(value);
  useEffect(() => {
    if (!chartdata || chartdata.length === 0) return;

    const years = chartdata.map((d) => d.year || "");

    let series = [];

    switch (genderValue) {
      case 1:
        series = [
          {
            name: "Male Cases",
            data: chartdata.map((d) => d.projected_male_cases || 0),
          },
        ];
        break;

      case 2:
        series = [
          {
            name: "Female Cases",
            data: chartdata.map((d) => d.projected_female_cases || 0),
          },
        ];
        break;

      case "both":
      default:
        series = [
          {
            name: "Male Cases",
            data: chartdata.map((d) => d.projected_male_cases || 0),
          },
          {
            name: "Female Cases",
            data: chartdata.map((d) => d.projected_female_cases || 0),
          },
        ];
        break;
    }

    setChartSeries(series);

    setChartOptions({
      chart: {
        type: "bar",
      },
      xaxis: {
        categories: years,
        title: {
          text: "Cases",
        },
      },
      yaxis: {
        title: {
          text: "Year",
        },
      },
      dataLabels: {
        enabled: false,
      },
      plotOptions: {
        bar: {
          horizontal: true,
          barHeight: "100%",
        },
      },
    });
  }, [chartdata, genderValue]);
  return (
    <div>
      <Chart
        options={chartOptions}
        series={chartSeries}
        type="bar"
        width={"100%"}
      />
    </div>
  );
};

export default TomorrowBarchart;
